import { getRegistryInfo } from "service/gatewayService";
import { Actuator, ActuatorCommandMode, ModeConfigs } from "types/Actuator";

const isWindSpeedOrRainFall = (APPId: string) =>
    APPId === "16386" || APPId === "16387";

/** Check if only Level mode should be allowed for a digital IO controller.
 * More info => IOTP-8810
 */
export const checkAllowLevelOnly = async ({
    isIOController,
    appId,
    gatewayId,
    ldsuId,
}: {
    isIOController: boolean;
    appId: string;
    gatewayId: string;
    ldsuId: string;
}): Promise<boolean> => {
    try {
        if (isIOController && appId === "32768") {
            const res = await getRegistryInfo(gatewayId);
            const ldsuInfo = res.data?.devices.find(
                (device: any) => device.UID === ldsuId
            );
            if (
                isWindSpeedOrRainFall(ldsuInfo?.APP?.[4]?.APPID) ||
                isWindSpeedOrRainFall(ldsuInfo?.APP?.[5]?.APPID)
            ) {
                return true;
            }
        }

        return false;
    } catch {
        // If registry info fails, don't restrict modes
        return false;
    }
};

export const getActuatorConfigTemplate = (actuator: Actuator) => {
    const {
        name,
        auto,
        mode,
        polarity,
        deactivate,
        timing,
        cycle_count,
        activate_value,
        deactivate_value,
    } = actuator;

    const defaultConfig = {
        name,
        auto,
        mode,
    };

    const modeConfigs: ModeConfigs = {
        [ActuatorCommandMode.LEVEL]: {
            polarity,
        },
        [ActuatorCommandMode.PULSE]: {
            deactivate,
            timing,
            polarity,
        },
        [ActuatorCommandMode.LOOP]: {
            deactivate,
            cycle_count: Number(cycle_count),
            timing,
            polarity,
        },
        [ActuatorCommandMode.PWM]: {
            deactivate,
            cycle_count: Number(cycle_count),
            timing,
            polarity,
        },
        [ActuatorCommandMode.ANALOG]: {
            activate_value: Number(activate_value),
            deactivate_value: Number(deactivate_value),
        },
        [ActuatorCommandMode.MOTOR]: {
            polarity,
        },
    };

    const body: Actuator = {
        ...defaultConfig,
        ...modeConfigs[mode],
    };

    return body;
};
